import { useTranslation } from 'next-i18next';

import { useI18n } from '@catawiki/cata-style';
import { Currency } from '@catawiki/runtime-toolkit';

import { toCurrency, toPercentage } from '@/shared/helpers/format';

import { getSellerFeeTiers } from '../../constants';

export const SellerFixedFeeTiers = () => {
  const i18n = useI18n();
  const { t } = useTranslation();

  const currency = Currency.CurrencyCodes.EURO;

  return (
    <table className="tw:w-full tw:border-collapse">
      <thead className="tw:sr-only">
        <tr>
          <th scope="col">{t('seller_register.secure.prices_title')}</th>
          <th scope="col">{t('seller_success_fee')}</th>
        </tr>
      </thead>
      <tbody>
        {getSellerFeeTiers().map((tier) => {
          const priceRange = tier.to
            ? `${toCurrency(i18n, tier.from, currency, {
                precision: 0,
              })} - ${toCurrency(i18n, tier.to, currency, {
                precision: 0,
              })}`
            : `${toCurrency(i18n, tier.from, currency, {
                precision: 0,
              })} +`;

          const feePercentage = toPercentage(i18n, tier.percent, {
            strip_insignificant_zeros: true,
          });

          const fixedFee = tier.fee
            ? ` + ${toCurrency(i18n, tier.fee, currency, {
                stripInsignificantZeros: Number.isInteger(tier.fee),
                precision: Number.isInteger(tier.fee) ? 0 : 2,
              })}`
            : '';

          return (
            <tr key={`${tier.from}-${tier.to}`}>
              <td className="tw:pb-xxs tw:whitespace-nowrap">{priceRange}</td>
              <td className="tw:pb-xxs tw:text-right tw:whitespace-nowrap">
                {feePercentage}
                {fixedFee}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
